"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _MdErrorOutline = require("@react-icons/all-files/md/MdErrorOutline");

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _TextInput = require("./TextInput.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextInput = function TextInput(props) {
  var className = props.className,
      disabled = props.disabled,
      error = props.error,
      hideOptionalText = props.hideOptionalText,
      id = props.id,
      format = props.format,
      floatingLabel = props.floatingLabel,
      label = props.label,
      maxLength = props.maxLength,
      _onBlur = props.onBlur,
      onChange = props.onChange,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      theme = props.theme,
      type = props.type,
      validations = props.validations,
      value = props.value,
      visible = props.visible;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onBlur'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register,
      setValue = _getFormMethods.setValue;

  var fieldErrors = error || errors[id];

  var _useState = (0, _react.useState)(value || ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      textValue = _useState2[0],
      setTextValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var filled = !!textValue && textValue.trim() !== '' && label !== textValue ? 'filled' : '';
  var focusOrFilled = focus || filled;
  var required = (0, _get["default"])(validations, 'required');
  var _theme$textInput$show = theme.textInput.showErrorIcon,
      showErrorIcon = _theme$textInput$show === void 0 ? true : _theme$textInput$show;
  (0, _react.useEffect)(function () {
    setTextValue(value);
    setValue(id, value);
  }, [id, setValue, value]);

  var handleChange = function handleChange(e) {
    onChange(e);
    var inputValue = e.target.value;

    if (format) {
      if (type === 'tel' && typeof format !== 'function') {
        inputValue = (0, _autobahnUtilities.formatPhone)(inputValue);
      } else {
        inputValue = format(inputValue);
      }
    }

    e.target.value = inputValue;
    setTextValue(inputValue);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputContainer, {
    className: "".concat(className, " ").concat(fieldErrors ? 'error' : ''),
    disabled: disabled,
    floatingLabel: floatingLabel,
    focus: focus,
    readOnly: readOnly,
    visible: visible
  }, label && /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputLabel, {
    disabled: disabled,
    floatingLabel: floatingLabel,
    focusOrFilled: focusOrFilled,
    htmlFor: id
  }, label, required && /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputRequired, {
    disabled: disabled
  }, "*"), !required && !hideOptionalText && /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputOptional, null, "(Optional)")), /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputObject, {
    "aria-label": label,
    className: filled,
    disabled: disabled,
    floatingLabel: floatingLabel,
    id: id,
    maxLength: maxLength,
    name: id,
    onBlur: function onBlur(e) {
      _onBlur(e);

      setFocus(false);
    },
    onChange: handleChange,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    readOnly: readOnly,
    ref: register(visible && validations),
    type: type,
    placeholder: floatingLabel && label ? '' : placeholder
  }), showErrorIcon && fieldErrors && /*#__PURE__*/_react["default"].createElement(_TextInput.StyledAlertIconContainer, {
    floatingLabel: floatingLabel
  }, /*#__PURE__*/_react["default"].createElement(_MdErrorOutline.MdErrorOutline, null))), fieldErrors && /*#__PURE__*/_react["default"].createElement(_TextInput.StyledTextInputError, null, fieldErrors.message));
};

TextInput.defaultProps = {
  className: '',
  disabled: false,
  error: undefined,
  format: undefined,
  floatingLabel: true,
  hideOptionalText: false,
  label: '',
  maxLength: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  placeholder: '',
  readOnly: false,
  type: 'text',
  validations: null,
  value: '',
  visible: true
};
TextInput.propTypes = {
  /** Apply custom class name to the container */
  className: _propTypes.string,

  /** Sets text input disabled state */
  disabled: _propTypes.bool,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** Autoformat input for supported types, or apply the function passed in */
  format: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.func]),

  /** Determines if label should float */
  floatingLabel: _propTypes.bool,

  /** Determines if the (Optional) text should show on optional inputs */
  hideOptionalText: _propTypes.bool,

  /** Input field unique identifier */
  id: _propTypes.string.isRequired,

  /** Input label */
  label: _propTypes.string,

  /** Maximum number of characters allowed on the field */
  maxLength: _propTypes.number,

  /** Function to be called when focus is removed from the text input */
  onBlur: _propTypes.func,

  /** Function to be called when the text input value is changed */
  onChange: _propTypes.func,

  /** Input Placeholder text  */
  placeholder: _propTypes.string,

  /** Sets text input readonly state */
  readOnly: _propTypes.bool,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Type of the Text Input */
  type: (0, _propTypes.oneOf)(['email', 'number', 'tel', 'text']),

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    max: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    maxLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    min: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    minLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    pattern: (0, _propTypes.shape)({
      value: (0, _propTypes.instanceOf)(RegExp),
      message: _propTypes.string
    }),
    validate: (0, _propTypes.shape)({})
  }),

  /** Initial value */
  value: _propTypes.string,

  /** Controls the visibility of the element, it will also affect the validation. */
  visible: _propTypes.bool
};
TextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextInput",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Apply custom class name to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets text input disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "format": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Autoformat input for supported types, or apply the function passed in",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "floatingLabel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines if label should float",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hideOptionalText": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Determines if the (Optional) text should show on optional inputs",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Input label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Maximum number of characters allowed on the field",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when focus is removed from the text input",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when the text input value is changed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Input Placeholder text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets text input readonly state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "description": "Type of the Text Input",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'email'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'tel'",
          "computed": false
        }, {
          "value": "'text'",
          "computed": false
        }]
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "max": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "maxLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "min": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "minLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "pattern": {
            "name": "shape",
            "value": {
              "value": {
                "name": "instanceOf",
                "value": "RegExp",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Initial value",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "visible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Controls the visibility of the element, it will also affect the validation.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "description": "Input field unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TextInput);

exports["default"] = _default;